
<button style="position:relative" class="{{animationClass}}" [nbSpinner]="isRunning && spinner" nbSpinnerStatus="{{spinnerStatus}}" nbButton [size]="size" status="{{status}}" [type]="type" [disabled]="disabled" (click)="pressed()">
  <div class="flex-space-between" >
    <app-icon *ngIf="icon" [icon]="icon" [disabled]="disabled" class="me-2"></app-icon>
    <span>{{label}}</span>
  </div>
  <nb-badge *ngIf="badgeStatus" style="margin: 2px" [dotMode]="true" [status]="badgeStatus" position="top right">
  </nb-badge>
</button>
